// isSpecialCharacter.js
export default (val) => {
  // 특수문자가 입력되었는지 거르는 필터(-_ 만 제외) 공백이고 뭐고 안됨.
  // !! 인명부의 이름에는 공백이 허용되야 하므로 사용할 수 없다.
  const spKey = /[\s{}[\]/?.,;:|)*~`!^+<>@#$%&\\=('"]/gi
  return spKey.test(val)
}
